import { Lineup } from '../../../interfaces/lineup';
import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Playout } from 'app/interfaces/playout';
import { Mediaclip } from 'app/interfaces/mediaclip';

@Component({
	selector: 'lineup-details-embed',
	templateUrl: './lineup-details-embed.component.html',
	styleUrls: ['./lineup-details-embed.component.scss']
})

export class LineupDetailsEmbedComponent implements OnInit {

	@Input() lineup: Lineup;
	@Input() form: NgForm;
	@Input() mediaclip: Mediaclip;

	constructor() { }

	ngOnInit() {

	}

	onPlayoutChanged(playout: Playout) {
		// this.onPlayoutChange.emit(playout);
	}
}
